<template>
  <v-app>
    <v-main class="pt-4">
      <v-card
        style="height: 60px;background-color: var(--v-background2-base);"
        class=" mt-0 mx-auto fill-width"
        max-width="640"
        flat
        justify-start
      >
        <div class="d-flex align-center">
          <div
            style="min-height:60px;min-width:5px; width:5px; height:100%;background-color:var(--v-secondary-base)"
            class="mr-4"
          />
          <div
            style="font-weight: bold;font-size: 18px;"
          >
            インポート
          </div>
        </div>
      </v-card>

      <v-card
        tile
        class="mb-10 mt-4 mx-auto fill-width"
        flat
        max-width="640"
      >
        <v-card-title class="text-subtitle-1">
          小説サイトのバックアップファイルから小説をインポートします
        </v-card-title>
        <div class="message">
          <p>現在、小説家になろう・カクヨム形式のバックアップファイルにのみ対応しています。</p>
          <p>
            今後アルファポリス形式への対応を予定しておりますが、順番に対応いたしますので該当サイトをご利用の方は今しばらくお待ちください。<br>
            上記以外のサイトのバックアップファイルをご利用になりたい方は、お問い合わせ頂けますと対応いたします。
          </p>
          <p>また、追加したての機能のためテストが行き届かず、不具合が発生した場合はお問い合わせよりご連絡ください。（Twitterでも可）</p>
          <div style="font-size: 13px;color:red;">
            現在、大量のデータを同期した場合のアプリの動作を修正したバージョンがアップデート審査中のため、一時的に1000話までのデータのみインポート可能としております。
          </div>
        </div>
        <div
          class="pt-4 mx-4"
          style="font-size: 13px;"
        >
          <ListIcon
            style="color:var(--v-secondary-base) ;width:6px;height:7px"
            class="mr-1"
          />
          読み込むバックアップファイルの生成元サイトを選択
        </div>
        <v-radio-group
          v-model="siteType"
          class="mx-4"
        >
          <v-radio
            key="0"
            :value="0"
          >
            <template v-slot:label>
              <div
                style="font-size: 13px;"
                class="text--primary"
              >
                小説家になろう
              </div>
            </template>
          </v-radio>
          <v-radio
            key="1"
            :value="1"
          >
            <template v-slot:label>
              <div
                style="font-size: 13px;"
                class="text--primary"
              >
                カクヨム
              </div>
            </template>
          </v-radio>
        </v-radio-group>
        <NaroImport v-if="siteType==0" />
        <KakuyomuImport v-if="siteType==1" />
      </v-card>
    </v-main>
  </v-app>
</template>

<script>
import NaroImport from "@/component/NaroImport";
import KakuyomuImport from "@/component/KakuyomuImport"
import ListIcon from "@/component/svg/ListIcon";
export default {
  name: "NovelImport",
  components:{
    NaroImport,
    KakuyomuImport,
    ListIcon
  },
  data(){
    return{
      siteType:null
    }
  }
}
</script>

<style scoped>
.message{
  border: var(--v-background-base) solid 1px;
  margin:12px;
  padding: 12px 8px 0px;
  font-size: 13px;
}
</style>